export class SetCookielessTrackingRequired {
  static readonly type = '[accountConfiguration] Set cookieless tracking required';
  constructor(public cookielessTrackingRequired: boolean) {}
}
